<template>
  <div>
    <Nav/>
    <transition  mode="out-in"
      :leave-active-class="leaveTransition"
      :enter-active-class="enterTransition">
        <router-view/>
    </transition>
  </div>
</template>
<script>
import Nav from '../components/Navbar_index'

export default {
    name: 'home',
    components: {
      Nav
    },
    data () {
      return {
        enterTransition: 'animated fadeIn',
        leaveTransition: 'animated fadeOut',
      }
    },
    watch: {
      '$route' (to, from) {
        let toDepth = to.meta.depth;
        let fromDepth = from.meta.depth;
        if (fromDepth > toDepth) {
          this.enterTransition = 'animated slideInLeft';
          this.leaveTransition = 'animated fadeOutRight';
        } else if (fromDepth < toDepth) {
          this.enterTransition = 'animated slideInRight';
          this.leaveTransition = 'animated fadeOutLeft';
        } else {
          this.enterTransition = 'animated fadeIn';
          this.leaveTransition = 'animated fadeOut';
        }
      }
    }
}
</script>
<style scoped>
  .animated{
    animation-delay: 0s!important;
  }
  .fadeOut,.fadeOutRight,.fadeOutLeft{
    animation-duration: 0.25s!important;
  }
  .slideInRight,.slideInLeft,.fadeInRight,.fadeInLeft,.fadeIn{
    animation-duration: 0.5s!important;
  }
</style>
